module.exports = __webpack_public_path__ + "img/full4-min.c565b4fd.png";